import { MetaData } from "@qid/core";

export class EncryptionKeys extends MetaData {

  account_id: string;
  key: string;
  salt: string;
  publicKey: string;
  recoveryKey: string;
  iv: string;
}
